import { ECustomerPaymentType } from "../../Enum/ECustomerPaymentType"
import { EPaymentType } from "../../Enum/EPaymentType"
import { EShippingCalculationMethodType } from "../../Enum/EShippingCalculationMethodType"
import { BaseModel } from "../Generics/BaseModel"
import { converteDateToSql } from "../Generics/Helps"

export class OrderPaymentEntity extends BaseModel {
  id: number

  employeeId: number

  employeeEntityId: string

  date: string

  status: ECustomerPaymentType

  ePaymentType: EPaymentType

  amountPaid?: number

  changeAmount: number

  description: string

  isOnlinePayment: boolean

  externalReference: string

  totalMeals: number

  totalDrinks: number

  totalNotLiquid: number

  totalDiscount: number

  totalBase: number

  totalCupom: number

  totalExtra: number

  totalFinal: number

  totalAward: number

  totalAddtionals: number

  shippingFee: number

  shippingCalculationMethod: EShippingCalculationMethodType

  isClosed() {
    return this.status === ECustomerPaymentType.WithOutDebit
  }

  constructor(data: Partial<OrderPaymentEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.employeeEntityId = data.employeeEntityId ?? ""

    this.date = data.date ?? converteDateToSql(new Date())

    this.description = data.description ?? ""

    this.isOnlinePayment = data.isOnlinePayment ?? false

    this.externalReference = data.externalReference ?? ""

    this.totalMeals = data.totalMeals ?? 0

    this.totalAddtionals = data.totalAddtionals ?? 0

    this.totalDrinks = data.totalDrinks ?? 0

    this.totalCupom = data.totalCupom ?? 0

    this.totalNotLiquid = data.totalNotLiquid ?? 0

    this.totalDiscount = data.totalDiscount ?? 0

    this.totalBase = data.totalBase ?? 0

    this.totalExtra = data.totalExtra ?? 0

    this.totalFinal = data.totalFinal ?? 0

    this.totalAward = data.totalAward ?? 0

    this.shippingFee = data.shippingFee ?? 0

    this.shippingCalculationMethod = data.shippingCalculationMethod ?? EShippingCalculationMethodType.Api

    this.status = data.status ?? ECustomerPaymentType.WithInDebit

    this.ePaymentType = data.ePaymentType ?? EPaymentType.None

    this.amountPaid = data.amountPaid

    this.changeAmount = data.changeAmount ?? 0
  }

  protected override getJsonFields(): string[] {
    return ["date", "status", "description", "isOnlinePayment", "ePaymentType", "amountPaid"]
  }

  isPaid() {
    return this.status === ECustomerPaymentType.WithInDebit
  }
}
